import gql from 'graphql-tag'

export const SEND_CONTRACT_TERMINATION = gql`
    mutation SendContractTermination($input: ContractTerminationInput!) {
        sendContractTermination(input: $input)
    }
`
